import { ReactNode } from "react";
import CustomModal from "../../../components/ui/CustomModal";

export interface ModalConfirmProps<
  DataT = never,
  TypeT =
    | "SUCCESS"
    | "ADD"
    | "UPDATE"
    | "VIEW"
    | "CONFIRM"
    | "CONFIRM_FOR_APPROVAL"
> {
  open: boolean;

  handleClose: (val?: any) => void;
  type?: TypeT;
  data?: DataT;
  children?: ReactNode;
}

export default function CashCollectionDetailsModal({
  handleClose,
  children,
  type,
  data,
  ...rest
}: ModalConfirmProps) {
  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={500}
        footer={null}
      >
        <div>{children}</div>
      </CustomModal>
    </>
  );
}
